'use strict';

const isNode = typeof document === 'undefined';

const _ = require('lodash');
const Classnames = require('classnames');
const jQuery = require('jquery');
const React = require('react');
const ReactRouter = require('react-router');
const LinkedStateMixin = require('react-addons-linked-state-mixin');

const History = ReactRouter.History;
const Link = ReactRouter.Link;

const Actions = require('../../store').Actions;
const Forms = require('../../forms');
const Components = require('../../components');
const Constants = require('../../constants');
var DynamicLayout = require('../../../../../common-js/dynamic-layout/dynamic-layout.js');
const Global = require('../../global');
const Moma = require('../../plugins/moma/');

import {Lightbox,Lightboxes} from "../../components/lightbox"
import {thumb, scaled} from "../../thumbs"
 

const Media = Components.Media;
const ResponsiveMixin = Global.ResponsiveMixin;

// From item-detail.jsx
const PRODUCT_THUMB_W = 600;

if (!isNode) {
    require('./item-tabs.scss');
}

module.exports = React.createClass({
    mixins: [ LinkedStateMixin, ResponsiveMixin ],

    _finishesIntro: function() {
        // Finishes tab starts with either Item or Standard description text
        // Standard description text has two variants to be used whether Finishes gallery exists or not
        // Item description text can be set at Item level, otherwise is inherited from Group or Category
        
        let intro = this.props.item.item.descriptions.finish;

        if (!intro) {
            if (this.props.item.finishes.length) {
                intro = this.props.item.text['collections.finishes'];
            } else {
                intro = this.props.item.text['collections.finishes-blank'];
            }
        }

        return (
            <div>
                {intro &&
                    <span dangerouslySetInnerHTML={{ __html: intro }} />
                }
            </div>
        );
    },
    render: function() {
        const finishesIntro = this._finishesIntro();

        // Item's description Splash, Story and Size are all concatenated together into the 'Story' tab
        var hasStory = this.props.item.item.descriptions.splash || 
                       this.props.item.item.descriptions.story ||
                       this.props.item.item.descriptions.size;

        var tabs = _.filter([
            hasStory ? {
                title: 'STORY',
                content: <ItemTabStory key  = 'tab-story'
                                       item = {this.props.item} />
            } : null,
            (this.props.item.item.descriptions.size) ? {
                title: 'DIMENSIONS',
                content: <ItemTabSize  key  = 'tab-size'
                                       item = {this.props.item}
                                       itemID = {this.props.item.item.id} />
            } : null,
            (this.props.item.details.length > 0) ? {
                title: 'DETAILS',
                content: <ItemTabGallery key    = 'tab-details'
                                         thumbs = {this.props.item.details}
                                         width  = {this.props.width}
                                         itemID = {this.props.item.item.id} />
            } : null,
            {
                title: 'FINISHES', 
                content: <ItemTabGallery key    = 'tab-finishes'
                                         thumbs = {this.props.item.finishes}
                                         width  = {this.props.width}
                                         itemID = {this.props.item.item.id}
                                         intro  = {finishesIntro}
                                         location = {this.props.location} />
            },
        ], (t) => {
            return t != null;
        });
        return (
            <StackableTabs item   = {this.props.item}
                           width  = {this.props.width}
                           height = {this.props.height}
                           tabs   = {tabs}
                           params   = {this.props.params}
                           location = {this.props.location} />
        );
    }
});

/*
 * Tabs on desktop that stack vertically to an accordion on mobile
 */
var StackableTabs = React.createClass({
    mixins: [ ResponsiveMixin ],

    renderDesktop: function(tab) {
        var tabCount = this.props.tabs.length;
        var w = Math.floor(this.props.width / tabCount);
        return (
            <div className='co-item-tabs' style={{ width: this.props.width }}>
                <div className='co-item-tab-bar'>
                    {this.props.tabs.map((t, ix) => {
                        var overflow = (ix == tabCount-1 && w * tabCount < this.props.width) ? 1 : 0;
                        return (
                            <ItemTab key         = {t.title}
                                     selected    = {tab == t}
                                     type        = {t.title.toLowerCase()}  // for links
                                     title       = {t.title}
                                     width       = {w + overflow}
                                     location    = {this.props.location} />
                        );
                    })}
                </div>
                <div className='co-item-tab-body-surround'>
                    <div className='co-item-tab-body' style={{ height: this.props.height }}>
                        {tab != null ?
                            tab.content
                        : null}
                    </div>
                    <div className='co-item-tab-body-scrollhint' />
                </div>
                <ItemControls {...this.props.item} />
            </div>
        );
    },
    renderMobile: function(tab) {
        return (
            <div className='co-item-tabs'>
                <ItemControls {...this.props.item} />
                <div className='co-item-tab-bar'>
                    {this.props.tabs.map((t, ix) => {
                        return (
                            <div key={t.title}>
                                <ItemTab selected     = {tab == t}
                                         type         = {t.title.toLowerCase()}  // for links
                                         title        = {t.title}
                                         continuation = {ix > 0 && this.props.tabs[ix-1] == tab}
                                         location     = {this.props.location} />
                                {tab == t ?
                                    <div className='co-item-tab-body'>
                                        {tab.content}
                                    </div>
                                : null}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    },
    render: function() {
        var _this = this;
        var tab = _.find(this.props.tabs, function(t) {
            return t.title.toLowerCase() == _this.props.params.tab;
        });
        if (this.state.viewportLayout == 'desktop' && !tab) {
            // Default to Story for desktop
            tab = this.props.tabs[0];
        }
        if (this.state.viewportLayout == 'desktop') {
            return this.renderDesktop(tab);
        } else {
            return this.renderMobile(tab);
        }
    }
});

var ItemControls = React.createClass({
    mixins: [ ResponsiveMixin ],

    addToProject: function() {
        Actions.addItem(this.props.item, 'item', 1);

        window.location = '/your-project';
    },
    render: function() {
        var button = (
            <Forms.Button type='prominent' onClick={this.addToProject} label='ADD TO YOUR QUOTE' />
        );
        return this.state.viewportLayout == 'desktop' ? (
            <div className='co-item-controls'>
                <Components.Howto text={this.props.text['collections.howto']} />
                {button}
            </div>
        ) : (
            <div className='co-item-controls'>
                {button}
                {/*<Global.Howto text={this.props.text['collections.howto']} />*/}
            </div>
        );
    }
});


var ItemTab = React.createClass({
    mixins: [ ResponsiveMixin, LinkedStateMixin ],

    render: function() {
        var classes = Classnames({
            'tabs-minimal':             true,
            'co-item-tab':              true,
            'co-item-tab-focus':        this.props.selected,
            'co-item-tab-continuation': this.props.continuation,
        });

        var style = {};
        if (this.props.width) {
            style.width = this.props.width;
        }

        if (this.props.selected) {
            var control = 'images/global/expansion/minus-grey1.png';
        } else {
            var control = 'images/global/expansion/plus-grey1.svg';
        }

        // Remove trailing /story or /finishes or /details, to replace with new tab
        var basepath = this.props.location.pathname.replace(/\/tab\/?(story|finishes|details|dimensions)$/, '');

        if (this.viewportLayout == 'desktop' || !this.props.selected) {
            var path = `${basepath}/tab/${this.props.type}`;
        } else {
            var path = basepath;
        }

        return (
            <Link to={path} state={{ scroll: false }} className={classes} style={style}>
                {this.props.title}
                {this.state.viewportLayout != 'desktop' ?
                    <div className='co-item-tab-control'>
                        <img src={Constants.static + control} alt='Expand' width="12" height="12"/>
                    </div>
                : null}
            </Link>
        );
    }
});

var ItemTabStory = React.createClass({
    render: function() {
        var descriptions = this.props.item.item.descriptions;
        return (
            <div className='co-item-tab-story'>
                <div dangerouslySetInnerHTML={{ __html: descriptions.splash }} />
                <div dangerouslySetInnerHTML={{ __html: descriptions.story }} />
            </div>
        );
    }
});

var ItemTabSize = React.createClass({
    render: function() {
        var descriptions = this.props.item.item.descriptions;
        return (
            <div className='co-item-tab-size'>
                <div dangerouslySetInnerHTML={{ __html: descriptions.size }} />
            </div>
        );
    }
});

var ItemTabDynamicGallery = React.createClass({
    mixins: [ History ],

    propTypes: {
        thumbs: React.PropTypes.array.isRequired,
        width: React.PropTypes.number.isRequired,
    },
    getInitialState: function() {
        return {
            rows: [],
        };
    },
    componentDidMount: function() {
        var _this = this;
        var params = {
            thumbs: this.props.thumbs,
            width: this.props.width - 40 - 17,
            targetHeight: 100,
            gap: 6,
        };            
        DynamicLayout.Distribute(params, rows => {
            _this.setState({
                // -40 as .co-item-tab-body { padding:20px }
                // -17 for scrollbar
                rows: rows
            }, function() {
                // Restory gallery scrollTop upon pressing Back from detail/finish photo
                if (history.state && history.state.tabScrollTop) {
                    jQuery('.co-item-tab-body').scrollTop(history.state.tabScrollTop);

                    // Remove property so when page is subsequently returned to (e.g. from another Item), gallery is reset to top
                    history.replaceState({
                        tabScrollTop: null,
                    }, window.location.pathname);
                }
            });
        });
    },
    _onClick: function(event) {
        // Store gallery scrollTop in location.state to restore upon pressing Back from detail/finish photo
        var tabScrollTop = jQuery('.co-item-tab-body').scrollTop();
        history.replaceState({
            tabScrollTop: tabScrollTop,
        }, window.location.pathname);
    },
    render: function() {
        var _this = this;
        var ix = 0;
        var thumbs = this.state.rows.map(row => {
            var thumbs = row.map(t => {
                var style = t.resize ? {
                    width: t.resize.width,
                    height: t.resize.height
                } : null;
                var thumb_img = (<Media media={t} key={ix++} width={t.resize.width} title={t.name} />);

                var w = Math.min(t.width, 1000);
                var h = Math.min(PRODUCT_THUMB_W, w * (1/t.aspect));
                w = h * t.aspect;

                var detail_img = (
                    <div>
                        {t.name ?
                            <h2>{t.name}</h2>
                        : null}
                        <Media media={t} key={ix++} />);
                    </div>
                );

                return (
                    <div key={ix++} className='co-item-tab-dynamic-gallery-row-thumb'>
                        <Lightbox src={t}>
                            <img 
                                 src={scaled(t, {height: t.resize.height})}
                                 />
                        </Lightbox>
                    </div>
                );
            });
            return (
                <div key={ix++} className='co-item-tab-dynamic-gallery-row'>
                    {thumbs}
                </div>
            );
        });
        var intro = this.props.intro;
        return (
            <div className='co-item-tab-dynamic-gallery' ref='scrollpane'>
                {intro ? intro : null}
                {thumbs}
            </div>
        );
    }
});

var ItemTabMomaGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            mobile: {
                portrait: {
                    width: 500,
                    height: 138,
                },
                landscape: {
                    width: 750,
                    height: 138,
                },
            },
        };
    },
    slideContent: function(slide, meta) {
        const height = meta ? meta.height : null;
        return (
            //make Lightboxable
            <div className='co-item-tab-moma-gallery-slide'>
                <Lightbox src={slide}>
                    <img 
                         src={scaled(slide, {height: height})}
                    />

                    {slide.name ?
                        <h6>
                            {slide.name}
                        </h6>
                    : null}
                </Lightbox>
            </div>
        );
    },
});

var ItemTabGallery = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        const gallerySpec = {
            mobile: {
                position: 'inside',
                graphic: 'simple',
                navigation: 'paged',
            },
        };
        if (this.state.viewportLayout == 'desktop') {
            return (
            <div>
                <ItemTabDynamicGallery thumbs   = {this.props.thumbs}
                                       width    = {this.props.width}
                                       intro    = {this.props.intro}
                                       location = {this.props.location}
                                       itemID   = {this.props.itemID} />
                <Lightboxes />
            </div>
            );
        } else {
            return (
                <div>
                    {this.props.intro ?
                        <div className='co-item-tab-gallery-intro'>
                            {this.props.intro}
                        </div>
                    : null}
                    {this.props.thumbs.length ?
                        <ItemTabMomaGallery gallery         = {this.props.thumbs}
                                            spec            = {gallerySpec}
                                            itemID          = {this.props.itemID} />
                    : null}
                    <Lightboxes />
                </div>
            );
        }
    },
});



// WEBPACK FOOTER //
// ./src/collections/product/item-tabs.jsx